/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ session: NonNullable<unknown> }} Plan_Build_Organize_NextInputs */

const en_us2_plan_build_organize_next = /** @type {(inputs: Plan_Build_Organize_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Next workout: ${i?.session}`)
};

const pt_br2_plan_build_organize_next = /** @type {(inputs: Plan_Build_Organize_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Próximo treino: ${i?.session}`)
};

const es_419_plan_build_organize_next = /** @type {(inputs: Plan_Build_Organize_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Próximo entrenamiento: ${i?.session}`)
};

const pt_pt2_plan_build_organize_next = /** @type {(inputs: Plan_Build_Organize_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Próximo treino: ${i?.session}`)
};

const fr_fr2_plan_build_organize_next = /** @type {(inputs: Plan_Build_Organize_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prochaine séance : ${i?.session}`)
};

const de_de2_plan_build_organize_next = /** @type {(inputs: Plan_Build_Organize_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nächstes Training: ${i?.session}`)
};

const it_it2_plan_build_organize_next = /** @type {(inputs: Plan_Build_Organize_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prossimo allenamento: ${i?.session}`)
};

/**
* | output |
* | --- |
* | "Next workout: {session}" |
*
* @param {Plan_Build_Organize_NextInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_organize_next = /** @type {((inputs: Plan_Build_Organize_NextInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Organize_NextInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_organize_next(inputs)
	if (locale === "es-419") return es_419_plan_build_organize_next(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_organize_next(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_organize_next(inputs)
	if (locale === "de-DE") return de_de2_plan_build_organize_next(inputs)
	if (locale === "it-IT") return it_it2_plan_build_organize_next(inputs)
	return en_us2_plan_build_organize_next(inputs)
});
export { plan_build_organize_next as "plan-build.organize_next" }